// Round illustrated bus icon for the "Autobusu ceļojumi" section header — same small colorful
// travel-illustration style as VacationIcon/FlightHotelIcon (gradient circle + flat shapes),
// instead of a thin outline bus icon, so all three product sections share one icon style.
export function BusIcon({ size = 72 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 72 72" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="bus-icon-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#dceeff" />
          <stop offset="1" stopColor="#bcdcff" />
        </linearGradient>
      </defs>
      <circle cx="36" cy="36" r="36" fill="url(#bus-icon-bg)" />
      <rect x="16" y="24" width="40" height="24" rx="6" fill="#0878f9" />
      <rect x="16" y="24" width="40" height="10" rx="4" fill="#4fa2ff" />
      <rect x="21" y="27" width="7" height="6" rx="1.5" fill="#eaf4ff" />
      <rect x="31" y="27" width="7" height="6" rx="1.5" fill="#eaf4ff" />
      <rect x="41" y="27" width="7" height="6" rx="1.5" fill="#eaf4ff" />
      <rect x="19" y="40" width="34" height="4" rx="2" fill="#eaf4ff" />
      <circle cx="25" cy="49" r="4.5" fill="#0c1b33" />
      <circle cx="25" cy="49" r="1.8" fill="#c7d3e6" />
      <circle cx="47" cy="49" r="4.5" fill="#0c1b33" />
      <circle cx="47" cy="49" r="1.8" fill="#c7d3e6" />
    </svg>
  );
}
